import React, { useEffect, useState, }  from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { GetUrl, GetMaintenanceUrl, formatNumber, CTicksToDateString } from '../Utility.js';
import { useNavigate } from 'react-router-dom';

function TimeTicketBuyModal({ isOpen, onClose}) {
    const state = useSelector((state)=>state);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [StartLogIndex, setStartLogIndex] = useState(1);
    const [IsTimeTicketBuyView, setTimeTicketBuyView] = useState(true);

    const [TotalLogCount, setTotalLogCount] = useState(-1);

    const [selectedIndex, setSelectedIndex] = useState(0);
    
    const timeTicketOptions = [
        { price : 30000, points: "30,000P", name: "1시간 이용권" },
        { price : 100000, points: "100,000P", name: "5시간 이용권", discount: "50,000P Off" },
        { price : 180000, points: "180,000P", name: "10시간 이용권", discount: "120,000P Off" },
        { price : 300000, points: "300,000P", name: "종일권(24시간)", discount: "420,000P Off" },
    ];

    const timeTicketNum = [
        1,
        2,
        3,
        4,
    ];

    if (!isOpen) return null;

    const Close = () =>{
        onClose();

        setStartLogIndex(1);
        setTimeTicketBuyView(true);
        setSelectedIndex(0);
    }

    const BuyTimeTicket = async () => 
        {
            try
            {
                if(state.Point < timeTicketOptions[selectedIndex].price)
                {
                    if(window.confirm("구매할수있는 포인트가 부족 합니다. \n충전 후 다시 이용하시겠습니까?")) {
                        Close();     
                        dispatch({type:'UpdateRechargePointModal', View:true});       
                    }
                    return;
                } 

                if(state.Request === 1)
                {
                    return;
                }
    
                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                  alert('유저 정보 만료(다시 로그인 해주세요)');  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                  return;    
                }
                
                dispatch({type:'Request'});
                const response = await fetch(GetUrl() + 'BuyTimeTicket/BuyTimeTicket', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secret_key : secretkey, ticket_no : timeTicketNum[selectedIndex], ticket_count : 1}),
                });
    
                if (response.ok) {
                    const data = await response.json();
                    if(data.result === 0)
                    {
                        if(window.confirm(timeTicketOptions[selectedIndex].name + " 구매 완료 했습니다. \n 바로 사용하시겠습니까?")) {
                            Close();     
                            dispatch({type:'UpdateTimeTicketUseModal', View:true});  
                        }

                        dispatch({type:'UpdatePoint', Point:data.cur_point});
                    }
                    else if(data.result === 14)
                    {
                        alert('시간권 구매 실패');  
                    }
                    else if(data.result === 3 ||
                            data.result === 1)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 20)
                    {
                        alert('구매할수있는 포인트가 부족 합니다. 충전 후 다시 이용해 주세요');  
                    } 
                    else if(data.result === 21) // 점검 중
                    {
                      var startTime = CTicksToDateString(data.start_time);
                      var endTime = CTicksToDateString(data.end_time);
        
                      var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                      alert(message);  
                      navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                } 
                else
                {
                    alert('Network Fail');
                }
    
                dispatch({type:'Response'});
            }
            catch(error)
            {
                alert('Network Fail');
                dispatch({type:'Response'});
                console.error(error);
            }
        };

    function LogStartIndexClick(index)
    {
        if(StartLogIndex === index)
        {
            return;
        }

        if(TotalLogCount === -1)
        {
            return;
        }

        var convertIndex = Math.ceil(TotalLogCount / 10);
        if(convertIndex < index)
        {
            return;
        }

        setStartLogIndex(index);

        RequestBuyTimeTecketLog(index);
    }

    function GetLogTime(index)
    {
        if(state.time_ticket_buy_log_array === undefined || state.time_ticket_buy_log_array.length <= index)
        {
            return'';
        }

        return CTicksToDateString(state.time_ticket_buy_log_array[index].create_time_ticks);
    }

    function GetLogCount(index)
    {
        if(state.time_ticket_buy_log_array === undefined || state.time_ticket_buy_log_array.length <= index)
        {
            return'';
        }

        return timeTicketOptions[state.time_ticket_buy_log_array[index].ticket_no - 1].name
        //return formatNumber(state.time_ticket_buy_log_array[index].ticket_count) + "개";
    }

    function GetLogPoint(index)
    {
        if(state.time_ticket_buy_log_array === undefined || state.time_ticket_buy_log_array.length <= index)
        {
            return'';
        }

        return formatNumber(state.time_ticket_buy_log_array[index].buy_point) + "P";
    }

    function ChangeView(view)
    {
        if(IsTimeTicketBuyView === view)
        {
            return;
        }

        setTimeTicketBuyView(view);
        if(view === false)
        {
            setStartLogIndex(1);

            RequestBuyTimeTecketLog(1);
        }
    }

    const RequestBuyTimeTecketLog = async (startIndex) => 
        {
            try
            {
                if(state.Request === 1)
                {
                    return;
                }
    
                dispatch({type:'UpdateTimeTicketBuyModalLog', Log:[]});           
    
                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                  alert('유저 정보 만료(다시 로그인 해주세요)');  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                  return;    
                }
                
                dispatch({type:'Request'});
                const response = await fetch(GetUrl() + 'SearchBuyTimeTicket/SearchBuyTimeTicket', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secret_key : secretkey, start_index : startIndex - 1, content_count:10 }),
                });
    
                if (response.ok) {
                    const data = await response.json();
                    if(data.result === 0)
                    {
                        setTotalLogCount(data.total_count);
                        dispatch({type:'UpdateTimeTicketBuyModalLog', Log:data.data_array});
                    }
                    else if(data.result === 3 ||
                            data.result === 1)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 21) // 점검 중
                    {
                      var startTime = CTicksToDateString(data.start_time);
                      var endTime = CTicksToDateString(data.end_time);
        
                      var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                      alert(message);  
                      navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                } 
                else
                {
                    alert('Network Fail');
                }
    
                dispatch({type:'Response'});
            }
            catch(error)
            {
                alert('Network Fail');
                dispatch({type:'Response'});
                console.error(error);
            }
        };

    return (
        <div className="time-ticket-buy-modal-overlay" onClick={Close}>
            <div className='time-ticket-buy-modal-button-box' onClick={(e) => e.stopPropagation()}>
                <div className="time-ticket-buy-modal" style={{backgroundColor: IsTimeTicketBuyView === true ? "RGB(255,255,255)" : "RGB(143,143,143)"}} onClick={() => ChangeView(true)}><h2>시간권 구매</h2></div>
                <div className="time-ticket-buy-log-modal" style={{backgroundColor: IsTimeTicketBuyView === true ? "RGB(143,143,143)" : "RGB(255,255,255)"}} onClick={() => ChangeView(false)}><h2>구매 내역</h2></div>
                <button className="time-ticket-buy-modal-close" onClick={Close}>
                    <h2>X</h2>
                </button>
            </div>
            <div className="time-ticket-buy-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className='time-ticket-buy-box' style={{ display: IsTimeTicketBuyView ? 'block' : 'none' }}>
                    <div className='point-recharge-body'>
                        <div className='point-recharge-point-title'>시간권 구매</div>
                        <div className='point-recharge-point'>
                            
                        <ul>
                            {timeTicketOptions.map((option, index) => (
                                <li key={index} onClick={() => setSelectedIndex(index)} className="point-recharge-option">
                                    <div className='point-recharge-info-bankbook-circle'>
                                        {selectedIndex === index && <div className='point-recharge-info-bankbook-circle2'></div>}
                                    </div>
                                    {option.points} <p>→</p><p><b>{option.name}</b><span>{option.discount}</span></p>
                                </li>
                            ))}
                        </ul>
                        </div>
                    </div>
                    <div className='point-recharge-button-blue' onClick={() => BuyTimeTicket()}><h2>구매하기</h2></div>

                </div>
                
                <div className='time-ticket-buy-log-box' style={{ display: IsTimeTicketBuyView ? 'none' : 'block'   }}>
                    <div className='time-ticket-buy-log-box-table'>
                      <table>
                        <thead>
                            <tr>
                                <th className='table-date'>구매 일시</th>
                                <th className='table-number'>구매 티켓</th>
                                <th className='table-point'>구매 포인트</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.from({length:10}).map((_, index)=>(
                                <tr key={index}>
                                    <td style={{textAlign:"center"}}>{GetLogTime(index)}</td>
                                    <td style={{textAlign:"right"}}>{GetLogCount(index)}</td>
                                    <td style={{textAlign:"center"}}>{GetLogPoint(index)}</td>
                                </tr>
                            ))}
                        </tbody>
                        </table>
                    </div>
                    <div className='time-ticket-buy-log-count-box'>
                        <div className='time-ticket-buy-log-count' onClick={() => LogStartIndexClick(1)}><h2 style={{fontWeight: StartLogIndex === 1 ? "bold" : "normal"}}>1</h2></div>
                        <div className='time-ticket-buy-log-count' onClick={() => LogStartIndexClick(2)}><h2 style={{fontWeight: StartLogIndex === 2 ? "bold" : "normal"}}>2</h2></div>
                        <div className='time-ticket-buy-log-count' onClick={() => LogStartIndexClick(3)}><h2 style={{fontWeight: StartLogIndex === 3 ? "bold" : "normal"}}>3</h2></div>
                        <div className='time-ticket-buy-log-count' onClick={() => LogStartIndexClick(4)}><h2 style={{fontWeight: StartLogIndex === 4 ? "bold" : "normal"}}>4</h2></div>
                        <div className='time-ticket-buy-log-count' onClick={() => LogStartIndexClick(5)}><h2 style={{fontWeight: StartLogIndex === 5 ? "bold" : "normal"}}>5</h2></div>
                        <div className='time-ticket-buy-log-count' onClick={() => LogStartIndexClick(6)}><h2 style={{fontWeight: StartLogIndex === 6 ? "bold" : "normal"}}>6</h2></div>
                        <div className='time-ticket-buy-log-count' onClick={() => LogStartIndexClick(7)}><h2 style={{fontWeight: StartLogIndex === 7 ? "bold" : "normal"}}>7</h2></div>
                        <div className='time-ticket-buy-log-count' onClick={() => LogStartIndexClick(8)}><h2 style={{fontWeight: StartLogIndex === 8 ? "bold" : "normal"}}>8</h2></div>
                        <div className='time-ticket-buy-log-count' onClick={() => LogStartIndexClick(9)}><h2 style={{fontWeight: StartLogIndex === 9 ? "bold" : "normal"}}>9</h2></div>
                        <div className='time-ticket-buy-log-count' onClick={() => LogStartIndexClick(10)}><h2 style={{fontWeight: StartLogIndex === 10 ? "bold" : "normal"}}>10</h2></div>

                    </div>
                </div>

            </div>
        </div>
    );
}

export default TimeTicketBuyModal;